<template>
  <div>
    <el-image :src="require('@/assets/img/s_top_03.png')" ></el-image>
  </div>
  <el-image :src="require('@/assets/img/bj_ej.png')" style="z-index: -100;position: absolute;"></el-image>
  <div class="bodyDiv">
    <div style="margin-right: 0">
      <!--      传来的参数id值是{{id}}中英文状态：{{lan=="中文"?"你好":'hello'}}-->
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("Nav.sy") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.jsyf") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.jsyf_yfcg") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contentDiv">
      <div class="leftDiv">
        <el-menu
            default-active="/technology/cooperation"
            @select="handleSelect"
            router="true">

          <el-menu-item index="/technology/team"><span>{{ $t("Nav.jsyf_yfdw") }}</span></el-menu-item>
          <el-menu-item index="/technology/patent"><span>{{ $t("Nav.jsyf_yqhz") }}</span></el-menu-item>
          <el-menu-item index="/technology/cooperation"><span>{{ $t("Nav.jsyf_yfcg") }}</span></el-menu-item>
          <el-menu-item index="/technology/achievements"><span>{{ $t("Nav.jsyf_zlbz") }}</span></el-menu-item>
        </el-menu>

      </div>
      <div class="rightDiv">
        <span v-if="lan=='zh'" v-html="showData.data.contextzh"></span>
        <span v-else v-html="showData.data.contexten"></span>
      </div>
    </div>
  </div>

</template>

<script setup>
import {ref, toRef, computed, reactive, onMounted} from 'vue'
import {useI18n} from 'vue-i18n'//要在js中使用国际化
import { useStore } from 'vuex'
import {axiosGet} from "../../api/api"; // 引入useStore 方法

const {locale} = useI18n()
const store = useStore()  // 该方法用于返回store 实例



const info =  ""
const infoEN = ""
let lan = computed(() => {
  return locale.value
})



function handleSelect(keyPath) {
  store.state.keyPath=keyPath;
}
onMounted(()=>{
  getInfo()
})

let showData=reactive({'data': {}})
function getInfo(){

  axiosGet("/prod-api/system/result/getWebInfo",{"type":32}).then(res=>{
    console.log(res)
    showData.data=res.data.data
  })
}
</script>

<style scoped>


</style>
